import api from '@/api/index.js'

const account_top_ups = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_ACCOUNT_TOP_UPS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_ACCOUNT_TOP_UPS: (state, topups) => {
      state.data = topups
      state.loading = false;
    },
    SET_ACCOUNT_TOP_UPS_ERROR: (state, error) => {
      state.error = error
      state.loading = false;
    }
  },

  actions: {
    GetUserTopUps({commit}, id) {
      commit('SET_ACCOUNT_TOP_UPS_LOADING', true)
      return api.get(`accounts/${id}/top-ups?limit=150&offset=0`)
        .then((response) => {
          commit('SET_ACCOUNT_TOP_UPS', response)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_TOP_UPS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    }
  }
}

export default account_top_ups
